export class AssociatesModel{
    employeeId :number;
    employeeName :string;
    mobileNum:number;
    deptId:number;
    constructor(employeeId :number,employeeName :string,mobileNum:number,deptId:number){
        this.employeeId = employeeId;
        this.employeeName = employeeName;
        this.mobileNum = mobileNum;
        this.deptId = deptId;
    }
}